import PropTypes from "prop-types";
import { useEffect, useState, Fragment } from "react";
import { matchPath, useLocation } from "react-router";

// material-ui
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";

// third-party
// import { FormattedMessage } from 'react-intl';

// project-imports
import NavItem from "./NavItem";
import NavCollapse from "./NavCollapse";
// import SimpleBar from 'components/third-party/SimpleBar';
import { MenuOrientation } from "config";
import useConfig from "hooks/useConfig";
import { useGetMenuMaster } from "api/menu";

// assets
// import { More2 } from 'iconsax-react';

// const PopperStyled = styled(Popper)(({ theme }) => ({
//   overflow: 'visible',
//   zIndex: 1202,
//   minWidth: 180,
//   '&:before': {
//     background: theme.palette.background.paper,
//     content: '""',
//     display: 'block',
//     position: 'absolute',
//     top: 5,
//     left: 32,
//     width: 12,
//     height: 12,
//     transform: 'translateY(-50%) rotate(45deg)',
//     zIndex: 120,
//     borderWidth: '6px',
//     borderStyle: 'solid',
//     borderColor: `${theme.palette.background.paper}  transparent transparent ${theme.palette.background.paper}`,
//     borderLeft: `1px solid ${theme.palette.divider}`,
//     borderTop: `1px solid ${theme.palette.divider}`
//   }
// }));

// ==============================|| NAVIGATION - GROUP ||============================== //

export default function NavGroup({
  item,
  lastItem,
  remItems,
  lastItemId,
  selectedID,
  setSelectedID,
  setSelectedItems,
  selectedItems,
  setSelectedLevel,
  selectedLevel,
}) {
  const theme = useTheme();
  const { pathname } = useLocation();

  const { menuOrientation, menuCaption } = useConfig();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;

  const downLG = useMediaQuery(theme.breakpoints.down("lg"));

  const [anchorEl, setAnchorEl] = useState(null);
  const [currentItem, setCurrentItem] = useState(item);

  const openMini = Boolean(anchorEl);

  useEffect(() => {
    if (lastItem) {
      if (item.id === lastItemId) {
        const localItem = { ...item };
        const elements = remItems.map((ele) => ele.elements);
        localItem.children = elements.flat(1);
        setCurrentItem(localItem);
      } else {
        setCurrentItem(item);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, lastItem, downLG]);

  const checkOpenForParent = (child, id) => {
    child.forEach((ele) => {
      if (ele.children?.length) {
        checkOpenForParent(ele.children, currentItem.id);
      }

      if (
        ele.url &&
        !!matchPath(
          { path: ele?.link ? ele.link : ele.url, end: true },
          pathname,
        )
      ) {
        setSelectedID(id);
      }
    });
  };
  const checkSelectedOnload = (data) => {
    const childrens = data.children ? data.children : [];
    childrens.forEach((itemCheck) => {
      if (itemCheck?.children?.length) {
        checkOpenForParent(itemCheck.children, currentItem.id);
      }

      if (
        itemCheck.url &&
        !!matchPath(
          { path: itemCheck?.link ? itemCheck.link : itemCheck.url, end: true },
          pathname,
        )
      ) {
        setSelectedID(currentItem.id);
      }
    });
  };

  useEffect(() => {
    checkSelectedOnload(currentItem);
    if (openMini) setAnchorEl(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, currentItem]);

  const navCollapse = item.children?.map((menuItem, index) => {
    switch (menuItem.type) {
      case "collapse":
        return (
          <NavCollapse
            key={menuItem.id}
            menu={menuItem}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedItems={selectedItems}
            level={1}
            parentId={currentItem.id}
          />
        );
      case "item":
        return <NavItem key={menuItem.id} item={menuItem} level={1} />;
      default:
        return (
          <Typography key={index} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <>
      {(menuOrientation === MenuOrientation.VERTICAL || downLG) && (
        <List
          subheader={
            <Divider
              sx={{
                my: "10px !important",
                width: "80%",
                margin: "auto",
                opacity: ".35",
                borderColor: "rgba(255,255,255,0.35)",
              }}
            />
          }
          sx={{
            mt: drawerOpen && menuCaption && item.title ? 1.5 : 0,
            py: 0,
            zIndex: 0,
          }}
        >
          {navCollapse}
        </List>
      )}
    </>
  );
}

NavGroup.propTypes = {
  item: PropTypes.any,
  lastItem: PropTypes.number,
  remItems: PropTypes.array,
  lastItemId: PropTypes.string,
  selectedID: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  setSelectedID: PropTypes.oneOfType([PropTypes.any, PropTypes.func]),
  setSelectedItems: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  selectedItems: PropTypes.oneOfType([PropTypes.string, PropTypes.any]),
  setSelectedLevel: PropTypes.func,
  selectedLevel: PropTypes.number,
};
